'use client';

import { useEffect, useMemo, type ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AccessibilityProvider } from './context/AccessibilityContext';
import { GlobalMusicProvider } from './context/GlobalMusicContext';
import { LanguageProvider } from './context/LanguageContext';
import { UiThemeProvider } from './context/UiThemeContext';
import type { LanguageCode } from './locales';
import { SiteChoicesProvider } from './context/SiteChoicesContext';
import { ToastProvider } from './context/ToastContext';
import { loadCompatibilityPolyfills } from './lib/compat/loadPolyfills';

export default function AppProviders({
  children,
  initialLanguage,
}: {
  children: ReactNode;
  initialLanguage?: LanguageCode;
}) {
  const queryClient = useMemo(() => new QueryClient(), []);

  useEffect(() => {
    void loadCompatibilityPolyfills();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <UiThemeProvider>
        <AccessibilityProvider>
          <LanguageProvider initialLanguage={initialLanguage}>
            <SiteChoicesProvider>
              <ToastProvider>
                <GlobalMusicProvider>{children}</GlobalMusicProvider>
              </ToastProvider>
            </SiteChoicesProvider>
          </LanguageProvider>
        </AccessibilityProvider>
      </UiThemeProvider>
    </QueryClientProvider>
  );
}
